import React from 'react';
import { Link } from 'react-router-dom';
import { SIGN_IN_METHODS_FAQ_PATH } from '@/lib/signInMethodsFaq';

export interface SignInMethodsHelpLinkProps {
  className?: string;
  /** e.g. close Account Settings so the FAQ is not hidden behind a modal. */
  onBeforeNavigate?: () => void;
}

const SignInMethodsHelpLink: React.FC<SignInMethodsHelpLinkProps> = ({
  className = '',
  onBeforeNavigate,
}) => (
  <Link
    to={SIGN_IN_METHODS_FAQ_PATH}
    className={className}
    onClick={() => onBeforeNavigate?.()}
  >
    Help with sign-in and merging accounts
  </Link>
);

export default SignInMethodsHelpLink;
